module.exports = __webpack_public_path__ + "static/media/nal.9c12907d.png";